import React from 'react';
import FilterField from 'app/containers/MainDashboard/components/FilterField.jsx';
import { useMainDashboardContext } from 'app/containers/MainDashboard/contexts/mainDashboardContext.jsx';
import { getCostTypeOptions } from 'shared/components/FilterSidebar/filterUtil.js';
import styles from './mainDashboardHeader.module.scss';

const filtersFields = {
  costType: { label: 'Cost Type', id: 'costType' },
  cost: { label: 'Cost', id: 'cost' },
  exclude: { label: 'Exclude', id: 'exclude' },
};

const MainDashboardFilters = () => {
  const { filters, setFilters, costOptions, excludeOptions } = useMainDashboardContext();

  return (
    <div className={styles.filterWrapper}>
      <FilterField
        filterType={filtersFields.costType}
        filterDataLength={0}
        isMulti
        onSelectMultiButtonClick={() => {}}
        selectedOptions={filters.costType || []}
        handleSelectionChange={(options) => setFilters({ ...filters, costType: options })}
        options={getCostTypeOptions(false)}
        width={215}
        height={160}
      />
      {costOptions?.length > 0 && (
        <FilterField
          filterType={filtersFields.cost}
          filterDataLength={0}
          handleSelectionChange={(options) =>
            setFilters({
              ...filters,
              cost: [options],
            })
          }
          onSelectMultiButtonClick={() => {}}
          selectedOptions={filters.cost || []}
          setSelectedOptions={(options) =>
            setFilters({
              ...filters,
              cost: [options],
            })
          }
          options={costOptions}
          height={costOptions?.length * 45}
          width={185}
        />
      )}
      {excludeOptions?.length > 0 && (
        <FilterField
          filterType={filtersFields.exclude}
          isMulti
          filterDataLength={0}
          onSelectMultiButtonClick={() => {}}
          selectedOptions={filters.exclude || []}
          handleSelectionChange={(options) => setFilters({ ...filters, exclude: options })}
          options={excludeOptions}
          height={120}
        />
      )}
    </div>
  );
};

export default MainDashboardFilters;
